import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * A full-screen fixed backdrop overlay
 */
export default function Overlay({
  children,
  classes,
  elementRef,
  open = true,
  variant = 'dark',
  ...htmlAttributes
}) {
  if (!open) {
    return null;
  }
  return _jsx("div", {
    "data-component": "Overlay",
    ...htmlAttributes,
    ref: downcastRef(elementRef),
    className: classnames('fixed top-0 left-0 w-full h-full z-10 flex items-center justify-center', {
      'bg-black/50': variant === 'dark',
      // default
      'bg-white/50': variant === 'light'
    }, classes),
    children: children
  });
}
//# sourceMappingURL=Overlay.js.map